import { useSelector } from 'react-redux';
import { PaymentMethodFundingSources } from '../../../types/PaymentsButtonViewConfig';
import { selectAvailableFundingSources, selectGooglePayButton } from '../../../selectors';
import { getGroupedExpressButtonsConfig, getExpressButtonsConfig } from '../utils/getButtonsViewConfig';

type Params = {
  expandableView?: boolean;
};

export const useExpressButtons = (params?: Params) => {
  const availableMethods = useSelector(selectAvailableFundingSources);
  const googlePayButton = useSelector(selectGooglePayButton);
  const methods = availableMethods.filter((method) => {
    // if Google decided to not show button, we should remove wrapper too
    if (method === PaymentMethodFundingSources.GooglePay) {
      return googlePayButton.visibility !== 'hidden';
    }

    return true;
  });

  if (params?.expandableView) {
    return getGroupedExpressButtonsConfig(methods);
  }

  return getExpressButtonsConfig(methods);
};
